/**
 * Simple logger utility that only outputs to the console in development mode.
 * Helps prevent sensitive data leakage in production logs.
 */

import ENV from './env';

const isDev = ENV.isDev;

export const logger = {
  debug: (...args: any[]) => {
    if (isDev) {
      console.debug(...args);
    }
  },
  info: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },
  warn: (...args: any[]) => {
    // Warnings are kept in production but might be sanitized
    console.warn(...args);
  },
  error: (...args: any[]) => {
    // Errors are always logged
    console.error(...args);
  },
  // Use this for sensitive data that should NEVER be logged even in dev
  // unless explicitly debugging a specific issue locally.
  sensitive: (label: string, data: any) => {
    if (isDev && window.location.hostname === 'localhost') {
      console.log(`[SENSITIVE] ${label}:`, data);
    }
  }
};

export default logger;
